type ListingLinkResolver = (props: Record<string, any>) => unknown;

const LISTING_LINK_BY_TYPE: Record<string, ListingLinkResolver> = {
  DynamicListWrapper: (props) => props?.cardConfig?.buttonLink,
  DynamicCarouselAndGridWrapper: (props) => props?.cardConfig?.buttonLink,
};

function typeNameOf(node: any): string {
  const type = node?.type;

  if (typeof type === "string") return type;
  if (type && typeof type === "object") return type.resolvedName ?? "";

  return "";
}

export function resolveListingLinks(
  pageData?: Record<string, any> | null,
): Record<string, string> {
  const links: Record<string, string> = {};

  Object.entries(pageData ?? {}).forEach(([nodeId, node]) => {
    const resolver = LISTING_LINK_BY_TYPE[typeNameOf(node)];
    if (!resolver) return;

    const link = resolver((node as any)?.props ?? {});
    if (typeof link !== "string") return;

    const trimmed = link.trim();
    if (trimmed.length === 0 || trimmed.includes("{{")) return;

    links[nodeId] = trimmed;
  });

  return links;
}
